import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import { useTripTaskStore } from 'shared/stores';
import { WarehouseSelector } from '../warehouse-selector';

export const WarehouseTaskForm = () => {
  const { t } = useTranslation('trip');
  const { warehouseId, setWarehouseId } = useTripTaskStore();

  return (
    <Flex gap='large' vertical>
      <Typography.Text type='secondary'>{t('select_warehouse')}</Typography.Text>
      <WarehouseSelector value={warehouseId} onChange={setWarehouseId} />
    </Flex>
  );
};
